import { motion } from 'framer-motion';

// Continuous ticker strip — lime green background by default, mono text with star separators
export const Marquee = ({ items = [], bg = '#D0FF3F', color = '#0B0B0B', reverse = false, star = '★' }) => {
  const loop = [...items, ...items, ...items, ...items];
  return (
    <div
      className="relative w-full overflow-hidden py-4 md:py-5 border-y border-ink"
      style={{ background: bg, color }}
      data-testid="marquee"
    >
      <div className={`marquee-track ${reverse ? 'animate-marquee-rev' : 'animate-marquee'}`}>
        {loop.map((item, i) => (
          <span
            key={i}
            className="font-mono uppercase tracking-widest2 text-xs md:text-sm px-6 md:px-10 whitespace-nowrap flex items-center gap-6"
          >
            <span>{item}</span>
            <span aria-hidden className="opacity-80">{star}</span>
          </span>
        ))}
      </div>
    </div>
  );
};

// Optional: a static (non-animated) marquee-like strip for eyebrow tag rows
export const TagRow = ({ items = [] }) => (
  <div className="flex flex-wrap items-center gap-x-3 gap-y-2 font-mono uppercase text-xs md:text-sm text-ink border-t border-b border-ink/40 py-3">
    <span aria-hidden className="opacity-60">▸</span>
    {items.map((item, i) => (
      <span key={i} className="flex items-center gap-3">
        {item}
        {i < items.length - 1 && <span aria-hidden className="opacity-40">·</span>}
      </span>
    ))}
  </div>
);
